/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MeanCurrent { 
    production?: number;
    cip?: number;
    startup?: number;
    standby?: number;
    slowing_down?: number;
}

